var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-form_radio_group"},[_c('form-label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"c-form_radio_group__container"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }